import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Scan } from '../../../common/model/dto/scan';
import { Resource } from '../../../common/model/type/resource.enum';
import useAuthorized from '../../../hooks/use-authorized';
import { useScanListColumns } from '../../../hooks/use-scan-list-columns';
import OvConfirmationDialog from '../molecules/OvConfirmationDialog';
import OvRecordList from './OvRecordList';

interface OvAdminScanListProps {
  scans: Scan[];
  deleteScanCallback: (scanId: string) => void;
}

const OvAdminScanList: FC<OvAdminScanListProps> = ({
  scans,
  deleteScanCallback,
}) => {
  const { t } = useTranslation();
  const applicationOperations = useAuthorized(Resource.Application);
  const scanOperations = useAuthorized(Resource.Scan);
  const scanReadAllowed =
    scanOperations.read || applicationOperations.supervise;
  const [deletableScanId, setDeletableScanId] = useState<string | null>(null);
  const columns = useScanListColumns(setDeletableScanId);

  const onConfirmDelete = () => {
    if (deletableScanId) {
      deleteScanCallback(deletableScanId);
    }

    setDeletableScanId(null);
  };

  return (
    <>
      <OvRecordList
        label={t('app.subPages.menu.scans')}
        records={scans}
        columns={columns}
        getKey={(scan) => scan.id ?? ''}
        getDetailsPath={
          scanReadAllowed ? (scan) => `/scan-list/${scan.id}` : undefined
        }
      />
      <OvConfirmationDialog
        isOpen={!!deletableScanId}
        onCancel={() => setDeletableScanId(null)}
        onConfirm={onConfirmDelete}
        description="common.dailyData.permanentScanDelete"
        title="common.areYouSure"
      />
    </>
  );
};

export default OvAdminScanList;
